import React from "react";
import { withTranslation } from "react-i18next";
import HardwareIndexTab from "./tabs/hardwareIndexTab/HardwareIndexTab";
import RemoteAttestationTab from "./tabs/remoteAttestationTab/RemoteAttestationTab";
import ReplacementDevicesTab from "./tabs/replacementDevicesTab/ReplacementDevicesTab";
import IsolationHardwareTab from "./tabs/isolationHardwareTab/IsolationHardwareTab";

import "./Hardware.css";
import {Col, Tab, Tabs, Container, Row} from "react-bootstrap";

class Hardware extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogApiError: "",
      apiError: ""
    };
  }

  async componentDidMount() {

  }


  render() {
    const { t } = this.props;


    return (
        <div>
          <Container className="mt-3">
            <Row>
              <Col>
                <Tabs
                    defaultActiveKey="Index"
                    id="uncontrolled-tab-example"
                    className="mb-3"
                >
                  <Tab eventKey="Index" title={t('Hardware.Tabs.Index.Title')} >
                    <HardwareIndexTab />
                  </Tab>
                  <Tab eventKey="IsolationHardware" title={t('Hardware.Tabs.IsolationHardware.Title')}>
                    <IsolationHardwareTab />
                  </Tab>
                  <Tab eventKey="ReplacementDevices" title={t('Hardware.Tabs.ReplacementDevices.Title')}>
                    <ReplacementDevicesTab />
                  </Tab>
                  <Tab eventKey="RemoteAttestation" title={t('Hardware.Tabs.RemoteAttestation.Title')}>
                    <RemoteAttestationTab />
                  </Tab>
                </Tabs>
              </Col>
            </Row>
          </Container>
        </div>
    );
  }
}

export default withTranslation()(Hardware);
